import color from "../../../constants/color";

const style = {
  container: {
    px: "15px",
    py: 2,
    backgroundColor: "#F1F1F1",
    minHeight: "100vh",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    mb: 3,
    flexWrap: "wrap",
    gap: 2,
  },
  title: {
    fontWeight: 600,
    fontSize: "24px",
    color: color.text,
    mb: 0.5,
  },
  subtitle: {
    fontSize: "14px",
    color: color.lightText,
  },
  addButton: {
    backgroundColor: color.primary,
    color: "#fff",
    borderRadius: "50px",
    textTransform: "none",
    px: 3,
    py: 1,
    fontWeight: 500,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "#228A3A",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    },
  },
  tableContainer: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  tableHeaderCell: {
    fontSize: { xs: "15px", md: "17px" },
    fontWeight: 500,
    lineHeight: 1.2,
    color: color.text,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  tableCell: {
    fontSize: "14px",
    color: color.text,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "#F9F9F9",
    },
  },
  inactiveRow: {
    backgroundColor: "#F5F5F5",
    opacity: 0.6,
  },
  actionButtons: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  editButton: {
    width: "30px",
    height: "30px",
    padding: 0,
  },
  editIcon: {
    width: "18px",
    height: "18px",
  },
  emptyCell: {
    py: 4,
    color: color.lightText,
  },
};

export default style;
